import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchBlacklistedContacts,
  resetError,
  updateListState
} from "./BlacklistedContactsList.actions";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { getLoggedInUser } from "services/AuthService";
import ContactModal from "components/BlacklistedContact/BlacklistContactModal";
import BlacklistedContactsListCommon from "./BlacklistedContactsListCommon";
import { COLUMN } from "./CreateColumnListForBlacklistedContactsList";
import { Button } from "react-bootstrap";

const DEFAULT_PAGE_SIZE = 15;

const COLUMN_LIST = [
  COLUMN.contactValue,
  COLUMN.contactType,
  COLUMN.description,
  COLUMN.creationDate,
  COLUMN.blacklistedBy,
  COLUMN.lastModifiedDate,
  COLUMN.lastModifiedBy,
];

const BlacklistedContactsList = () => {
  const dispatch = useDispatch();

    const {
      data,
      pages,
      totalElements,
      loading,
      isError,
      listState,
  } = useSelector((state) => {
    const pageSize =
      state.blacklistedContactsList.pageSize || DEFAULT_PAGE_SIZE;
    return {
      data: state.blacklistedContactsList.data || [],
      pages: Math.ceil(
        (state.blacklistedContactsList.totalCount || 0) / pageSize
      ),
      totalElements: state.blacklistedContactsList.totalCount || 0,
      loading: state.blacklistedContactsList.loading,
      isError: state.blacklistedContactsList.isError,
      listState: {
        page: state.blacklistedContactsList.page || 0,
        pageSize,
        filtered: state.blacklistedContactsList.filtered || [],
      },
    };
  });

  const [showModal, setShowModal] = useState(false);

  const fetchWithFilters = useCallback(() => {
    const { pageSize, filtered = [] } = listState;
    dispatch(fetchBlacklistedContacts(0, pageSize, filtered));
  }, [dispatch, listState]);

  const resetList = useCallback(() => {
    const { pageSize } = listState;
    dispatch(fetchBlacklistedContacts(0, pageSize, []));
  }, [dispatch, listState]);

  const handleActionComplete = useCallback(() => {
    const { page, pageSize, filtered } = listState;
    dispatch(fetchBlacklistedContacts(page, pageSize, filtered));
    window.location.reload();
  }, [dispatch, listState]);

    const currentUserId = getLoggedInUser().uuid;

  // Initial fetch on mount (mimic old componentDidMount behavior – run once)
  React.useEffect(() => {
    fetchWithFilters();
  }, []);

    return (
      <Container className="list-container" fluid>
        <Row>
          <Col md={12}>
            <div
              className="codex-version-display-bar"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "10px",
                position: "relative",
              }}
            >
              <span>
                Total Blacklisted Contacts: <strong>{totalElements}</strong>
              </span>

              <strong
                style={{
                  position: "absolute",
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
              >
                Blacklisted Contacts List
              </strong>

            <Button variant="warning" onClick={() => setShowModal(true)}>
                Blacklist Contact
              </Button>

              <ContactModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                createdBy={currentUserId}
                contactToEdit={null}
                onActionComplete={handleActionComplete}
              />
            </div>
          </Col>
        </Row>

        <BlacklistedContactsListCommon
        updateBlacklistedContactsList={(page, pageSize, filters) =>
          dispatch(fetchBlacklistedContacts(page, pageSize, filters))
        }
          resetError={() => dispatch(resetError())}
          data={data}
          pages={pages}
          totalElements={totalElements}
          loading={loading}
          listState={listState}
          isError={isError}
          columnList={COLUMN_LIST}
          isSortFilterEnabledForCust={true}
        onActionComplete={handleActionComplete}
        updateListState={(payload) =>
          dispatch(updateListState(payload.page, payload.pageSize, payload.filtered))
        }
        />
      </Container>
    );
};

export default BlacklistedContactsList;
